window.popupChoice=function(){
    $(".mask").height($(document).height());
    $(".mask,.popup_choice").show();
    $(".popup_choice .close").click(function(){
        $(".mask,.popup_choice").hide();
    })
};

window.popupClose=function(){
    $(".mask,.popup_choice").hide();
};
window.popupJoin=function(){
    $(".mask").height($(document).height());
    $(".mask,.popup_join").show();
    $(".popup_join .close").click(function(){
        $(".mask,.popup_join").hide();
    })
};

window.enroll=function(){
    $(".mask").height($(document).height());
    $(".mask,.popup_enroll").show();
    $(".popup_enroll .close").click(function(){
        $(".mask,.popup_enroll").hide();
    })
};

/*视频弹窗*/
window.popupVideo=function(url){
    $(".mask").height($(document).height());
    $(".mask,.popup_video").show();
    $(".popup_video_content").html("<video id=\"video\" width=\"100%\" height=\"100%\" autoplay loop controls=\"controls\"><source src=\"" + url + "\" type=\"video/mp4\" width=\"100%\" height=\"100%\"></video>");
    $(".popup_video .close").click(function(){
        $(".mask,.popup_video").hide();
        $(".popup_video_content").html('')
    })
};
